// Copyright © Veeam Software Group GmbH

import { of } from 'rxjs';
import { map } from 'rxjs/operators';

import type { Observable } from 'rxjs';
import type { Override1 } from 'infrastructure/types';
import type { VersionableItem } from 'services/models';

import { Batch, loadPages } from 'infrastructure/rxjs';
import { convertFileItemFromRest, convertFolderItemFromRest } from './converters';
import { exploreSessionService } from 'services/exploreSessions';
import { teamsApi } from './wrapped-teams-api';
import { RESTTeamsFileFileTypeEnum } from '../../../../api/rxjs';

import type { TeamsFileItem, TeamsFolderItem } from '../../../models/Teams';
import type { GetItemVersionsRequest } from '../../interfaces/get-item-versions-request';

export type GetTeamsVersionsRequest = Override1<GetItemVersionsRequest, 'parent', TeamsFileItem | TeamsFolderItem>;

export const getTeamsVersions = ({ parent, config }: GetTeamsVersionsRequest): Observable<Batch<VersionableItem>> => {
    const { vetSession } = exploreSessionService.getSessions();

    if (!vetSession) {
        console.error('');
        return of(Batch.empty());
    }

    return loadPages(teamsApi.getFileVersions, config)({
        restoreSessionId: vetSession,
        fileId: parent.id,
        teamId: parent.teamId,
        channelId: parent.channelId,
    }).pipe(
        map(files => files.mapData(
            (file) => {
                if (file.fileType === RESTTeamsFileFileTypeEnum.Folder) {
                    return convertFolderItemFromRest(file, true, parent as any);
                }

                return convertFileItemFromRest(file, true, parent as any);
            }
        )),
    );
};
